/**
 * La politique de confidentialité : sa version, et où la lire.
 *
 * ## Pourquoi une constante et pas une chaîne recopiée
 *
 * Chaque autorisation d'image enregistrée porte la version du texte qui était
 * affiché au moment de la réponse (`kid_image_rights.policy_version`). C'est ce
 * qui rend le consentement prouvable : « il a dit oui » ne veut rien dire si on
 * ne sait pas à quoi.
 *
 * Recopier « 0.1 » dans le formulaire ET dans la page aurait garanti qu'un jour
 * les deux divergent — et ce jour-là, les consentements enregistrés citeraient
 * une version que personne n'a jamais pu lire.
 *
 * ## Ce qu'il faut faire en publiant une nouvelle version
 *
 * Changer `VERSION` ici ne suffit pas et ne doit pas suffire : les réponses
 * déjà données restent valables, elles citent simplement le texte de leur
 * époque. Si une nouvelle version change ce à quoi les familles ont consenti,
 * c'est une re-demande qu'il faut, pas un numéro qu'il faut incrémenter.
 */

/** La version affichée en tête de la politique, et inscrite avec chaque consentement. */
export const VERSION_POLITIQUE = '0.1';

/** La date de dernière mise à jour, telle qu'elle figure sur le document. */
export const MAJ_POLITIQUE = '11 septembre 2026';

/** L'adresse de la page publique qui porte le texte. */
export const CHEMIN_POLITIQUE = '/confidentialite';

/**
 * Le document source, partagé par Éclosion.
 *
 * La page du site fait foi pour les familles — c'est elle qui est datée,
 * versionnée et citée par les consentements. Ce lien reste offert pour qui
 * préfère le document d'origine (impression, diffusion interne).
 */
export const DOCUMENT_SOURCE =
  'https://docs.google.com/document/d/1wQ5iDVUYosNvoeCa7dJsV8_hw0n7uXwn9kn75OjFIBQ/edit?usp=sharing';

/** L'adresse à qui s'adressent les demandes relatives aux données. */
export const COURRIEL_VIE_PRIVEE = 'vieprivee@eclosion.be';
